export default __webpack_public_path__ + "static/media/amsaiduongthac.7f35c07e.png";